// reducers/userReducer.js
import { createReducer } from "@reduxjs/toolkit";
import { setUser, clearUser } from "../slices/UserSlices";

// Initial state for the user
const initialState = { name: "", id: null , type:"" ,address:"",contact:"",email: ""};

// Create a reducer using createReducer from Redux Toolkit
export const userReducer = createReducer(initialState, {
  [setUser]: (state, action) => {
    state.name = action.payload.name;
    state.id = action.payload.id;
    state.type = action.payload.type;
    state.address = action.payload.address;
    state.contact = action.payload.contact;
    state.email = action.payload.email;
  },
  [clearUser]: (state) => {
    state.name = "";
    state.id = null;
    state.type = "";
    state.address = "";
    state.contact = "";
    state.email = "";
  },
});
